import { Container, ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React from 'react';
import { isOfertaV2 } from 'src/bff';
import { removeConsecutiveDuplicates, removeParagraphTags, underlineToMarkdownBold } from 'src/helpers';
import { Offer } from 'src/types';

interface LegalesOfertaProps {
	oferta: Offer;
}

export const LegalesOferta = ({ oferta }: LegalesOfertaProps) => {
	if (!oferta) return null;
	if (isOfertaV2(oferta)) {
		// Este debera ser el unico return cuando ofertasV2 este publicado
		return (
			oferta.datosEconomicos?.length > 0 && (
				<>
					{oferta.datosEconomicos.map((datoEconomico, index) => (
						<Container key={index} padding={{ top: ContainerPadding.static200 }}>
							<Text staticSize appearance={TokenTextAppearance.copy100}>
								{removeConsecutiveDuplicates(removeParagraphTags(datoEconomico.legal))}
							</Text>
						</Container>
					))}
				</>
			)
		);
	} else if ((oferta as any).calculatedFinance?.rawResponse?.Response?.Parameters?.GlobalDisclaimer) {
		return (
			<Text staticSize appearance={TokenTextAppearance.copy100}>
				{underlineToMarkdownBold((oferta as any).calculatedFinance.rawResponse.Response.Parameters.GlobalDisclaimer)}
			</Text>
		);
	} else {
		return (
			<>
				<Text staticSize appearance={TokenTextAppearance.copy100}>
					{removeConsecutiveDuplicates(removeParagraphTags((oferta as any).legal))}
				</Text>
				<Container padding={{ top: ContainerPadding.static200 }}>
					<Text staticSize appearance={TokenTextAppearance.copy100}>
						{removeConsecutiveDuplicates(removeParagraphTags((oferta as any).cuotaLegal))}
					</Text>
				</Container>
			</>
		);
	}
};
